
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/translate",
      function () {
        return require("private-next-pages/translate.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/translate"])
      });
    }
  